import { http } from "Utils/http";
import { STATUSES } from "Utils/constants";

// initial load User Profile/Reset Password page
const getResetPWDUserInfo = async (token) => {

  let status = STATUSES.SUCCESS;
  let body = {};

  const url = "/api/manage/loadChangePassword";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then((res) => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    //console.log("getResetPWDUserInfo()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// auto ws pwd generator
const getGeneratePWD = async (token) => {

  let status = STATUSES.SUCCESS;

  //console.log("acctStatus", acctStatus);
  const url = "/api/manage/generateRandomUserPassword";
  const res = await http.post(url, {}, {
    headers: {
      "Authorization": token
    }
  }).then(res => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    //console.log("getGeneratePWD()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// submit Reset Password 
const submitResetPassword = async (token, email, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue) => {
  //console.log("submitResetPassword() axios", token, email, formInfo, getFieldValue("conNewPassword", formInfo.data));
  //clearErrorMessages(formInfo.data);

  var request = {
    newPassword: getFieldValue("newPassword", formInfo.data),
    confirmPassword: getFieldValue("conNewPassword", formInfo.data),
  }

  //console.log("submitResetPassword() request", request);

  var url = "/api/manage/myaccount/changepassword";

  var status = STATUSES.SUCCESS;

  const res = await http.post(url, request, {
    headers: {
      "Authorization": token
    }
  }).then(res => {
    //console.log("submitResetPassword()", res);
    var x = 0;
    var isFirst = false;
    for (const [key, value] of Object.entries(nameConverter)) {

      var d = res.fieldErrors;
      var values = d[key];

      if (values != null) {
        if (x == 0) {
          isFirst = true;
        }
        else {
          isFirst = false;
        }
        addErrorMessages(value, key, res, isFirst);
        status = STATUSES.ERROR;
        x = x + 1;
      }
    }

    return Promise.resolve({ status: status, data: res });

  }).catch(function (error) {
    //console.log("error caught from submitEditWSAccount()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });
  return res;
};

// trigger pwd validation for password creation rules
const validateResetPassword = async (token, pwd) => {

  let status = STATUSES.SUCCESS;
  let body = {
    "password": pwd,
  };

  //console.log("validateResetPassword() body", body);
  const url = "/api/manage/validateUserProfilePwd";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then((res) => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {

    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

export { getResetPWDUserInfo, getGeneratePWD, submitResetPassword, validateResetPassword }